import React, { useCallback, useEffect, useState } from "react";
import { api } from "../lib/api";
import { bn, fmtDate, fmtTime } from "../lib/format";
import { Loader, Empty, GlassPage, GlassHeader } from "../components/kit";

const ACTION: Record<string, [string, string]> = {
  create: ["তৈরি", "bg-emerald-500/20 text-emerald-300"],
  edit: ["এডিট", "bg-blue-500/20 text-blue-300"],
  archive: ["আর্কাইভ", "bg-rose-500/20 text-rose-300"],
  restore: ["রিস্টোর", "bg-amber-500/20 text-amber-300"],
  adjust: ["সমন্বয়", "bg-amber-500/20 text-amber-300"],
  import: ["ইমপোর্ট", "bg-blue-500/20 text-blue-300"],
  day_close: ["দিন ক্লোজ", "bg-emerald-500/20 text-emerald-300"],
};
const ENTITY: Record<string, string> = { product: "পণ্য", customer: "ক্রেতা", memo: "মেমো", payment: "পেমেন্ট", stock: "স্টক", purchase: "ক্রয়", report: "রিপোর্ট" };
const ENTITIES = ["", "product", "customer", "memo", "payment", "stock", "purchase", "report"];

export default function Activity() {
  const [list, setList] = useState<any[] | null>(null);
  const [entity, setEntity] = useState("");
  const [date, setDate] = useState("");
  const load = useCallback(() => {
    setList(null);
    api.get("/audit", { params: { entity, date } }).then((r) => setList(r.data));
  }, [entity, date]);
  useEffect(() => { load(); }, [load]);

  return (
    <GlassPage testid="activity-log-page">
      <GlassHeader title="অ্যাক্টিভিটি লগ" subtitle="অ্যাপে কে, কখন, কী করেছে তার পূর্ণ রেকর্ড" />
      <div className="glass-card p-4 flex flex-col sm:flex-row gap-3 mb-4">
        <select className="ginp sm:w-56" value={entity} onChange={(e) => setEntity(e.target.value)} data-testid="activity-entity-filter">
          {ENTITIES.map((e) => <option key={e} value={e}>{e ? ENTITY[e] : "সব ধরন"}</option>)}
        </select>
        <input type="date" className="ginp sm:w-48" value={date} onChange={(e) => setDate(e.target.value)} data-testid="activity-date-filter" />
      </div>
      <div className="glass-card overflow-x-auto">
        {!list ? <Loader /> : list.length === 0 ? <Empty text="কোনো রেকর্ড নেই" /> : (
          <table className="w-full text-sm" data-testid="activity-table">
            <thead><tr className="text-slate-400 text-left border-b border-white/10"><th className="px-5 py-3 font-medium">সময়</th><th className="px-3 py-3 font-medium">কাজ</th><th className="px-3 py-3 font-medium">ধরন</th><th className="px-3 py-3 font-medium">বিবরণ</th><th className="px-5 py-3 font-medium">কে</th></tr></thead>
            <tbody>
              {list.map((a) => (
                <tr key={a.id} className="border-b border-white/5 hover:bg-white/5" data-testid={`activity-row-${a.id}`}>
                  <td className="px-5 py-3 num text-slate-300 whitespace-nowrap">{fmtDate(a.date)} {fmtTime(a.created_at)}</td>
                  <td className="px-3 py-3"><span className={`inline-flex items-center text-xs font-semibold px-2.5 py-0.5 rounded-full ${ACTION[a.action]?.[1] || "bg-slate-400/20 text-slate-200"}`}>{ACTION[a.action]?.[0] || a.action}</span></td>
                  <td className="px-3 py-3 text-slate-300">{ENTITY[a.entity] || a.entity}</td>
                  <td className="px-3 py-3 text-slate-100">{a.summary}</td>
                  <td className="px-5 py-3 text-slate-400">{a.user}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </GlassPage>
  );
}
